import React, { createContext, useContext, useState, useEffect } from 'react';
import { getStoredLanguage, setStoredLanguage, getBrowserLanguage, t } from '../utils/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getStoredLanguage());

  // Update language state when localStorage changes
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'appLanguage') {
        setLanguageState(e.newValue || getBrowserLanguage());
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const changeLanguage = (newLanguage) => {
    if (newLanguage !== language) {
      setLanguageState(newLanguage);
      setStoredLanguage(newLanguage);
      
      // Trigger a custom event to notify components about language change
      window.dispatchEvent(new CustomEvent('languageChanged', { 
        detail: { language: newLanguage } 
      }));
    }
  };

  const translate = (key, params = {}) => t(key, language, params);

  const value = {
    language,
    changeLanguage,
    translate,
    t: translate
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 